import axios from 'axios';

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

axios.defaults.headers.common = {
  'Cache-Control': 'no-cache, no-store, must-revalidate',
  Pragma: 'no-cache',
  Expires: '0',
};
